import { Input, Rate } from "antd";
import dayjs from "dayjs";
import React from "react";
import { $t } from "~/i18n.js";

import { DatePicker, Flex, Radio } from "antd";
import { BevoegdheidExpirationWarning } from "./BevoegdheidExpirationWarning.jsx";
import { ParseMessage } from "~/components/atom/parseMessage.jsx";

export const ScoreForm = ({
  bevoegdheid,
  score,
  remark,
  setScore,
  setRemark,
  date_assigned,
  setDateAssigned,
  date_geldig,
  setDateGeldig,
}) => {
  const handleScoreChange = (nextScore) => {
    setScore(nextScore);
    setDateAssigned(dayjs());
  };

  return (
    <Flex vertical={true} gap={24}>

      <ParseMessage message={bevoegdheid.description} />

      {bevoegdheid.scoring == "bd_rank" && (
        <Flex align="center" gap={24}>
          <span>{$t("Stage")}:</span>
          <Radio.Group
            size="medium"
            buttonStyle="solid"
            value={score}
            onChange={(event) => handleScoreChange(event.target.value)}
          >
            <Radio.Button value="briefing">{$t("briefing")}</Radio.Button>
            <Radio.Button value="demo">{$t("demo")}</Radio.Button>
          </Radio.Group>
        </Flex>
      )}
      {(bevoegdheid.scoring === "rank" || bevoegdheid.scoring == "bd_rank") && (
        <Flex align="center" gap={24}>
          <span>{$t("Score")}:</span>
          <Rate onChange={handleScoreChange} value={score} style={{ fontSize: 32 }} />
        </Flex>
      )}

      {bevoegdheid.has_remark && (
        <div>
          <p>{$t("Opmerking")}:</p>
          <Input.TextArea
            rows={3}
            value={remark}
            onChange={(elm) => setRemark(elm.target.value.substring(0, 499))}
          />
        </div>
      )}

      <Flex align="center">
        <p>{$t("Datum behaald")}:</p>
        <DatePicker
          value={date_assigned}
          style={{ marginLeft: 12 }}
          format={localStorage.localeFormat}
          allowClear={false}
          onChange={setDateAssigned}
          disabled={!score || score == 0 || score == "revoked"}
          disabledDate={(current) => current && current > dayjs().endOf("day")}
        />
      </Flex>

      {date_geldig && (
        <Flex align="center">
          <p>{$t("Geldig tot")}:</p>
          <DatePicker
            value={date_geldig}
            style={{ marginLeft: 12 }}
            format={localStorage.localeFormat}
            allowClear={false}
            onChange={setDateGeldig}
            disabled={!score || score == 0 || score == "revoked"}
            disabledDate={(current) =>
              current && current < dayjs().endOf("day")
            }
          />

          <BevoegdheidExpirationWarning bevoegdheid={bevoegdheid} />
        </Flex>
      )}
    </Flex>
  );
};
